import React from "react";
import { Select } from "antd";

interface Props {
  value: string[];
  onChange: (tags: string[]) => void;
  disabled?: boolean;
}

const PONumberTagInput: React.FC<Props> = ({ value, onChange, disabled = false }) => {
  const handlePaste = (e: React.ClipboardEvent<HTMLDivElement>) => {
    const text = e.clipboardData.getData("text");
    const parsed = text
      .split(/[\n,\s]+/)
      .map((s) => s.trim())
      .filter(Boolean);
    if (parsed.length === 0) return;
    e.preventDefault();
    const merged = Array.from(new Set([...value, ...parsed]));
    onChange(merged);
  };

  return (
    <div onPaste={handlePaste}>
      <Select
        mode="tags"
        className="po-number-tag-input"
        style={{ width: "100%" }}
        value={value}
        onChange={onChange}
        tokenSeparators={[",", "\n"]}
        placeholder="Type or paste PO numbers (separated by space)"
        disabled={disabled}
        open={false}
        allowClear
        size="large"
      />
      <style>{`
        .po-number-tag-input .ant-select-selector {
          max-height: 120px !important;
          overflow-y: auto !important;
          overflow-x: hidden !important;
        }
        .po-number-tag-input .ant-select-selection-overflow {
          max-height: 120px !important;
          overflow-y: auto !important;
        }
      `}</style>
    </div>
  );
};

export default PONumberTagInput;
